import { StatusPill, type InvoiceStatus as PillStatus } from '@/components/ui/StatusPill'
import { STATUS_COPY, statusHint } from '@/lib/invoice-status-copy'
import type { InvoiceStatus } from '@/lib/invoice-types'

const MAP: Record<InvoiceStatus, PillStatus> = {
  DRAFT: 'concept',
  PARKED: 'concept',
  PENDING_APPROVAL: 'approval',
  APPROVED: 'approved',
  SENT: 'sent',
  ESCALATED: 'escalated',
  PAID: 'paid',
  WITHDRAWN: 'closed',
  WRITTEN_OFF: 'closed',
  VOIDED: 'closed',
  REPLACED: 'closed',
}

export interface StatusDetail {
  escalatedAt?: string | null
  escalationReason?: string | null
  closedAt?: string | null
  closureReason?: string | null
}

export function InvoiceStatusPill({
  status,
  className,
  detail,
}: {
  status: InvoiceStatus
  className?: string
  detail?: StatusDetail
}) {
  return (
    <StatusPill
      status={MAP[status]}
      className={className}
      labelOverride={STATUS_COPY[status].label}
      hint={statusHint(status, detail)}
    />
  )
}

/** Het filteren zelf staat in lib/invoice-buckets.ts. */
